module.exports = __webpack_public_path__ + "img/birds_nest.c9daeabd.png";